import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const BackTopBottom = Loadable({
    loader: () => import(/* webpackChunkName: "BackTopBottom" */ './backTopBottom'),
    loading: () => <div />,
});
